import { useLogger, useNuxtApp } from "#imports";
export function getCurrentServerName() {
  const nuxtApp = useNuxtApp();
  const logger = useLogger();
  let host = "";
  if (import.meta.server) {
    if (!nuxtApp.ssrContext?.event.node.req) {
      logger.warn("No request in SSR context ?!", nuxtApp.ssrContext, nuxtApp.ssrContext?.req);
    } else {
      host = nuxtApp.ssrContext.event.node.req.headers?.origin ?? "";
    }
  } else {
    host = window.location.origin;
  }
  return host;
}
